import React from 'react';

export default function CountryFlag({ code, flag, name, className = '' }) {
  const iso = (code || '').toLowerCase();
  return (
    <span className={`relative inline-flex overflow-hidden bg-white ${className}`} aria-label={`Drapeau ${name || code || ''}`}>
      <span className="absolute inset-0 flex items-center justify-center text-2xl" aria-hidden="true">{flag || '🌍'}</span>
      {iso ? (
        <img
          src={`https://flagcdn.com/w80/${iso}.png`}
          srcSet={`https://flagcdn.com/w160/${iso}.png 2x`}
          alt={`Drapeau de ${name || code}`}
          loading="lazy"
          className="relative z-10 h-full w-full object-cover"
          onError={(event) => { event.currentTarget.style.display = 'none'; }}
        />
      ) : null}
    </span>
  );
}
